import TextareaWrapper from './TextareaWrapper';

export type { TextareaProps } from './Textarea.types';

export default TextareaWrapper;
